import { createContext, useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { MQTT_TOPIC } from 'constants/appConstants'
import { mqttConnect, mqttDisconnect, mqttSubscribe, mqttUnSubscribe } from 'services/mqtt-service'

const MqttClientContext = createContext()
const SCREEN_INFO_KEY = 'screenWeb'

export const MqttClientProvider = ({ children }) => {
  const [mqttClient, setMqttClient] = useState()
  const [screenId, setScreenId] = useState(
    localStorage.getItem(SCREEN_INFO_KEY) ? JSON.parse(localStorage.getItem(SCREEN_INFO_KEY)).value : null
  )
  const [zoneId, setZoneId] = useState(null)

  const getScreenTopic = () => `${MQTT_TOPIC}${screenId}`
  const getZoneTopic = () => `${MQTT_TOPIC}zone/${zoneId}`

  const updateScreenId = newScreenId => setScreenId(newScreenId)
  const updateZoneId = newZoneId => setZoneId(newZoneId)

  const updateSubscription = topic => {
    if (!mqttClient || topic.endsWith('null') || topic.endsWith('undefined')) {
      return
    }

    mqttSubscribe(mqttClient, topic)
    return () => {
      if (!mqttClient?.disconnecting && !mqttClient?.disconnected) {
        mqttUnSubscribe(mqttClient, topic)
      }
    }
  }

  useEffect(() => {
    if (!mqttClient) {
      setMqttClient(mqttConnect())
    }

    if (mqttClient) {
      mqttClient.on('error', err => {
        console.error('Connection error: ', err)
        mqttDisconnect(mqttClient)
        setMqttClient(null)
      })

      mqttClient.on('message', (topic, message) => (mqttClient.lastMessage = message))

      return () => {
        mqttDisconnect(mqttClient)
        setMqttClient(null)
      }
    }
  }, [mqttClient])

  useEffect(() => updateSubscription(getScreenTopic()), [mqttClient, screenId])
  useEffect(() => updateSubscription(getZoneTopic()), [mqttClient, zoneId])

  return (
    <MqttClientContext.Provider value={{ mqttClient, updateScreenId, updateZoneId }}>
      {children}
    </MqttClientContext.Provider>
  )
}

MqttClientProvider.propTypes = {
  children: PropTypes.any,
}

export const useMqttClient = () => useContext(MqttClientContext)
